import './exo-home-lite-r01.js';
/* Keep the partner configurator inline: Shopify product pages cannot be framed. */
(() => {
  function initialize(root = document) {
    root.querySelectorAll('[data-partner-rollercam]').forEach(host => {
      if (host.dataset.observing) return;
      host.dataset.observing = 'true';
      const observer = new IntersectionObserver(async entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        observer.disconnect();
        const template = host.querySelector('[data-partner-content]');
        host.append(template.content.cloneNode(true));
        template.remove();
        host.querySelector('[data-partner-loading]')?.remove();
        try { await import(host.dataset.module); host.dataset.loaded = 'true'; }
        catch (error) {
          host.dataset.loaded = 'error';
          const note = document.createElement('p');
          note.textContent = 'Open the full strap builder to explore this setup.';
          note.setAttribute('role', 'status'); host.prepend(note);
        }
      }, { rootMargin: '120px' });
      observer.observe(host);
      const link = host.closest('[data-orbit-item]').querySelector('.brand-panel__actions a');
      link.addEventListener('click', () => {
        const selection = new URLSearchParams(location.search);
        const query = new URLSearchParams();
        for (const key of ['rc', 'buckle', 'qty', 'kits', 'kitv']) if (selection.has(key)) query.set(key, selection.get(key));
        link.href = '/products/rollercam-strap-assembly-builder' + (query.size ? '?' + query : '') + '#configure';
      });
    });
    window.EXOBrandOrbit?.initialize(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

// Homepage workshops use the same color codes and handoff parameters as the full builders.
function homeWorkshop(root) {
  if (root.dataset.workshopReady) return;
  root.dataset.workshopReady = 'true';
  const coil = root.querySelector('[data-webbing]'), q = s => coil.querySelector(s);
  const pairs = {'ncaa-oregon-ducks':['#00934B','#FFF41B'],'nfl-seattle-seahawks':['#002A5C','#69BE28'],'ncaa-washington-state-cougars':['#A60F2D','#4D4D4D']};
  coil.dataset.treatment = 'reversible'; coil.dataset.reverse = 'false';
  function handoff() {
    const team=q('[data-coil-colors]').value, reverse=coil.dataset.reverse==='true', solid=coil.dataset.treatment==='solid';
    const colors=pairs[team],strip=q('[data-coil-strip]'),words=q('[data-coil-text]').value.replace(/[\r\n\t]/g,' ').slice(0,36);
    strip.style.background=colors[reverse?1:0];strip.style.color=colors[reverse?0:1];strip.textContent=words||'MAKE IT YOURS';
    coil.querySelectorAll('[data-team]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.team===team)));
    const link=q('[data-coil-link]'),url=new URL(link.href);
    for(const [key,value] of Object.entries({mode:'team',team,finish:q('[data-coil-finish]').value,width:q('[data-coil-width]').value,text:words,role:reverse?'secondary':'primary',treatment:solid?(reverse?'alternate':'solid'):'reversible'}))url.searchParams.set('sw_'+key,value);
    link.href=url.pathname+url.search;
  }
  coil.addEventListener('click',e=>{
    const team=e.target.closest('[data-team]'),treatment=e.target.closest('[data-coil-treatment]'),reverse=e.target.closest('[data-coil-reverse]');
    if(team)q('[data-coil-colors]').value=team.dataset.team;
    if(treatment){coil.dataset.treatment=treatment.dataset.coilTreatment;coil.querySelectorAll('[data-coil-treatment]').forEach(b=>b.setAttribute('aria-pressed',String(b===treatment)));}
    if(reverse){coil.dataset.reverse=String(coil.dataset.reverse!=='true');reverse.setAttribute('aria-pressed',coil.dataset.reverse);}
    if(team||treatment||reverse)q('[data-coil-colors]').dispatchEvent(new Event('change',{bubbles:true}));
  });
  coil.addEventListener('change',handoff);coil.addEventListener('input',handoff);handoff();
  const olo=root.querySelector('[data-olo]');
  const observer=new IntersectionObserver(async entries=>{
    if(!entries.some(e=>e.isIntersecting))return;observer.disconnect();
    try{const module=await import(olo.dataset.testerModule);await module.mount(olo);}
    catch{olo.querySelector('[data-olo-status]').textContent=olo.dataset.unavailable;}
  },{rootMargin:'160px'});observer.observe(olo);
}
document.querySelectorAll('[data-exl]').forEach(homeWorkshop);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-exl]').forEach(homeWorkshop));
